import { FileWarning, Lightbulb, PlugZap, ShieldCheck } from 'lucide-react';

const problems = [
  {
    icon: PlugZap,
    title: 'Your systems do not talk to each other',
    description:
      'Customer, job, and invoice data gets copied by hand, drifts out of sync, or is lost between platforms.',
  },
  {
    icon: FileWarning,
    title: 'Your automation is fragile and manual',
    description: 'Scripts, Zaps, and re-entry are doing important work without enough reliability.',
  },
  {
    icon: Lightbulb,
    title: 'You have AI ideas but need the architecture',
    description: 'We turn fuzzy AI concepts into scoped workflows with the right tools, access rules, and safeguards.',
  },
  {
    icon: ShieldCheck,
    title: 'You want honest scope and a quote first',
    description: 'No inflated agency layer. Every project is scoped, with outcome, timeline, and cost up front.',
  },
];

export function IdealCustomerSection() {
  return (
    <section id="problems" className="w-full bg-[var(--color-paper)] py-16 md:py-24 lg:py-28">
      <div className="container px-4 md:px-6">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[var(--color-copper)]">
            Common problems
          </p>
          <h2 className="mt-3 text-3xl font-semibold leading-tight text-[var(--color-ink)] sm:text-5xl">
            We step in when off-the-shelf tools stop being enough
          </h2>
        </div>
        <div className="mx-auto mt-12 grid max-w-4xl gap-4 md:grid-cols-2">
          {problems.map(({ icon: Icon, title, description }) => (
            <article key={title} className="rounded-lg border border-[var(--color-line)] bg-white p-5">
              <Icon className="h-7 w-7 text-[var(--color-copper)]" />
              <h3 className="mt-4 text-xl font-semibold text-[var(--color-ink)]">{title}</h3>
              <p className="mt-3 leading-7 text-[var(--color-muted)]">{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
